<template>
  <div
    id="reports"
    class="row"
  >
    <div class="col-12">
      <v-col
        v-if="dowloading"
        class="subtitle-1 text-center"
        cols="12"
      > Cargando por favor espere...
      </v-col>
      <v-progress-linear
        indeterminate
        :background-color="backgroundLoadingColor"
        :color="loadingColor"
        height="10"
        v-if="dowloading"
      ></v-progress-linear>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="reset"
        @keydown="form.onKeydown($event)"
      >
        <v-container grid-list-xl>
          <toolbar
            :title="title"
            :loading="form.busy"
            :buttons="buttons"
            @getDocuments="getDocuments"
            @downloadExcel="downloadExcel"
          />
          <v-layout
            :id="ref"
            class="wrap justify-space-around form-body"
          >
            <v-col lg="10" md="10" sm="10" cols="12">
              <vuetify-select :states="cat_province_id" />
            </v-col>
            <v-col lg="2" md="2" sm="2" cols="12">
              <v-switch
                  v-model="form.alarmada"
                  :input-value="form.alarmada === 1"
                  inset
                  color="red"
                  :label="label"
                  @change="toggleActiveAl(form.alarmada)"
                ></v-switch>
              </v-col>
          </v-layout>
        </v-container>
      </v-form>
    </div>
    <div class="col-12">
      <v-data-table
        v-if="documents != 0"
        :headers="headers"
        :items="documents"
        :class="`elevation-1 ${navbarColor}`"
      >
      <template v-slot:item.modality="{ item }">
        <div v-if="item.modality == 0">
          <v-chip
            color="cyan"
            dark
          >
            Prepago
          </v-chip>
        </div>
        <div v-else>
          <v-chip
            color="indigo"
            dark
          >
            Postpago
          </v-chip>
        </div>
      </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import Form from 'vform';
import { mask } from 'vue-the-mask';
import { mapGetters } from 'vuex';
import Toolbar from '~/components/Toolbar';
import VuetifySelect from '~/components/VuetifySelect';
import 'vuetify/src/styles/main.sass';

Form.axios = window.axios;
export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('reportNumeration') };
  },
  components: {
    Toolbar,
    VuetifySelect,
  },
  computed: {
    ref() {
      return this.form.id;
    },
    ...mapGetters({
      user: 'auth/user',
      loadingColor: 'theme/loadingColor',
      backgroundLoadingColor: 'theme/backgroundLoadingColor',
      navbarColor: 'theme/navbarColor',
    }),
  },
  directives: {
      mask,
    },
  data: () => ({
    title: 'Reporte de Numeraciones',
    form: new Form({
      documentType: null,
      busy: false,
      dateAnnulment: '',
      typePortal: 'A',
      enterpriseId: '',
      serieB: '',
      alarmada: 0,
    }),
    label: 'Todas',
    itemsProvince: [],
    valid: false,
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
      numeric: (v) => /^([0-9])*$/.test(v) || 'El campo solo permite caracteres numericos.',
      format: (v) => /^(?=.*[0-9])/.test(v) || 'El campo solo permite caracteres numericos.',
      rucLength: (v) => (!v || v.length <= 12) || 'El campo debe tener máximo 12 caracteres.',
      rucFormat: (v) => (!v || /^[V,J,E,P,G]{1}[-][0-9]{1,9}[-][0-9]{1} || [V,J,E,P,G]{1}[-][0-9]{1,9}$/.test(v)) || 'Formato inválido.',
    },
    allHeaders: [
    {
      text: 'RIF',
      value: 'rif',
      align: 'left',
      sortable: true,
    },
    {
      text: 'Razón Social',
      value: 'name',
      align: 'left',
      sortable: true,
    },
    {
      text: 'Tipo de Documento',
      value: 'type_document',
      align: 'left',
      sortable: true,
    }, {
      text: 'Serie',
      value: 'serie',
      align: 'left',
      sortable: true,
    },
    {
      text: 'Prefijo',
      value: 'prefix',
      align: 'left',
      sortable: true,
    },
    {
      text: 'Mínimo',
      value: 'min_value',
      align: 'left',
      sortable: true,
    }, {
      text: 'Máximo',
      value: 'max_value',
      align: 'left',
      sortable: true,
    }, {
      text: 'Correlativo',
      value: 'correlative',
      align: 'left',
      sortable: true,
    }, {
      text: 'Capacidad usada',
      value: 'capacity_used',
      align: 'left',
      sortable: true,
    }, {
      text: 'Modalidad',
      value: 'modality',
      align: 'left',
      sortable: true,
    },
  ],
    documents: 0,
    dowloading: false,
    buttons: [
      {
          id: 'save',
          icon: 'mdi-file-find',
          name: 'Generar Vista Previa',
          event: 'getDocuments',
          color: 'blue darken-1',
       },
      {
        id: 'cancel',
        icon: 'mdi-download',
        name: 'Descargar Excel',
        event: 'downloadExcel',
        color: 'green',
      },
    ],
    cat_province_id: '',
  }),
  methods: {
    toggleActiveAl(alarmada) {
      if (alarmada) {
        this.label = 'Alarmadas';
        this.documents = '';
      } else {
        this.label = 'Todas';
        this.documents = '';
      }
    },
    getDocuments() {
          this.validate();
          if (this.$refs.form.validate()) {
            this.dowloading = true;
            this.form.enterpriseRif = this.$store.state.taxpayer.rif;
            this.form.serie = this.form.serieB;
            const filteredFields = [];
            const url = '/api/getNumerations'; // Ruta que nos devuelva todos los datos del reporte
            this.form.post(url).then((response) => {
              this.documents = response.data.item; // creamos array & guardamos el contenido que nos devuelve el response
              this.headers = this.allHeaders;

              this.headers = this.headers.filter((header) => filteredFields.indexOf(header.text) === -1);
              setTimeout(() => { this.dowloading = false; }, 500);
            })
            .catch(() => {
            });
          }
    },
   downloadExcel() {
        if (!this.documents) {
              this.$store.dispatch('notifications/show', {
                message: 'El archivo Excel NO contiene registros que coincidan con los criterios de búsqueda.',
                type: 'error',
              });
            } else {
              this.dowloading = true;
                this.form.enterpriseRif = this.$store.state.taxpayer.rif;
                const url = '/api/reportNumerations/export';
                window.axios({
                  method: 'post',
                  url,
                  responseType: 'arraybuffer',
                  data: this.form,
                }).then((response) => {
                    this.downloadFile(response, `Reporte de Numeraciones  ${new Date().toISOString().slice(0, 10)}`);

                    setTimeout(() => { this.dowloading = false; }, 1000);
                })
                .catch(() => {
                });
            }
    },
    downloadFile(response, filename) {
      // Es necesario crear un nuevo objeto blob con mime-type establecido explícitamente
      // de lo contrario, solo Chrome funciona como debería  //application/vnd.ms-excel
      // application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
      const newBlob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
      // IE no permite usar un objeto blob directamente como enlace href, en su lugar, es necesario usar msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      // Para otros navegadores: Cree un enlace que apunte al ObjectURL que contiene el blob..
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = data;
      // link.download = `${filename }.xlsx`;
      link.download = (this.form.alarmada) ? `${filename} Alarmadas.xlsx` : `${filename}.xlsx`;
      link.click();
      setTimeout(() => {
        // Para Firefox es necesario retrasar la revocación de ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.form.busy = true;
        if (this.$store.state.taxpayer.rif === null) {
          this.valid = false;
        } else {
          this.valid = true;
        }
      }
    },
  },
};
</script>
